<template>
	<section class="h-full flex flex-col overflow-hidden">
		<!-- dev tool selector menu  -->
		<nav class="flex flex-wrap px-24 mb-16 text-gray-100 gap-x-20 gap-y-4" data-test="dev-tools-navigation">
			<button
				v-for="[pane, toolName] in Object.entries($sessionLayout.devToolsPanes)"
				:key="pane"
				:disabled="$sessionLayout.devToolsPane === pane"
				:class="{'text-gray-400': $sessionLayout.devToolsPane !== pane}"
				:name="toolName"
				data-test="dev-tools-console-button"
				class="select-none text-strong-base whitespace-nowrap"
				@click="$sessionLayout.openDevToolsPane(pane)"
			>
				<span>{{ toolName }}</span>
			</button>
		</nav>
		<!-- dev tool panes  -->
		<KeepAlive>
			<SessionNetwork v-if="$sessionLayout.devToolsPane === 'network'" />
			<SessionSystem v-else-if="$sessionLayout.devToolsPane === 'system'" />
			<SessionTestHelpers v-else-if="$sessionLayout.devToolsPane === 'test'" />
			<SessionConsole v-else />
		</KeepAlive>
	</section>
</template>

<script>
import {defineAsyncComponent} from 'vue'
// Always import the Console pane, since that's by far the most used one, and the bundle is small.
import SessionConsole from 'shared/components/SessionConsole.vue'

export default {
	name: 'SessionDevTools',
	components: {
		SessionConsole,
		SessionNetwork: defineAsyncComponent(() => import('shared/components/SessionNetwork.vue')),
		SessionSystem: defineAsyncComponent(() => import('shared/components/SessionSystem.vue')),
		SessionTestHelpers: defineAsyncComponent(() => import('shared/components/SessionTestHelpers.vue')),
	},
}
</script>
